/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Action } from '@ngrx/store';
import { Driver } from '@shared/models';

export const LOAD_DRIVERS = '[Drivers] Load';
export const LOAD_DRIVERS_SUCCESS = '[Drivers] Load success';
export const LOAD_DRIVERS_FAILURE = '[Drivers] Load failure';
export const EDIT_DRIVER = '[Driver] Edit';
export const LOAD_DRIVER = '[Driver] Load';
export const LOAD_DRIVER_SUCCESS = '[Driver] Load success';
export const LOAD_DRIVER_FAILURE = '[Driver] Load failure';
export const PERSIST_DRIVER = '[Driver] Persist';
export const PERSIST_DRIVER_SUCCESS = '[Driver] Persist success';
export const PERSIST_DRIVER_FAILURE = '[Driver] Persist failure';
export const DELETE_DRIVER = '[Driver] Delete';
export const DELETE_DRIVER_SUCCESS = '[Driver] Delete success';
export const DELETE_DRIVER_FAILURE = '[Driver] Delete failure';
export const DEACTIVATE_DRIVER = '[Driver] Deactivate';
export const DEACTIVATE_DRIVER_SUCCESS = '[Driver] Deactivate success';
export const DEACTIVATE_DRIVER_FAILURE = '[Driver] Deactivate failure';

export class LoadDrivers implements Action {
  readonly type = LOAD_DRIVERS;
}

export class LoadDriversSuccess implements Action {
  readonly type = LOAD_DRIVERS_SUCCESS;
  constructor(public drivers: Driver[]) { }
}

export class LoadDriversFailure implements Action {
  readonly type = LOAD_DRIVERS_FAILURE;
}

export class EditDriver implements Action {
  readonly type = EDIT_DRIVER;
  constructor(public driverId?: string) { }
}

export class LoadDriver implements Action {
  readonly type = LOAD_DRIVER;
  constructor(public driverId?: string) { }
}

export class LoadDriverSuccess implements Action {
  readonly type = LOAD_DRIVER_SUCCESS;
  constructor(public driver: Driver) { }
}

export class LoadDriverFailure implements Action {
  readonly type = LOAD_DRIVER_FAILURE;
}

export class PersistDriver implements Action {
  readonly type = PERSIST_DRIVER;
  constructor(public driver: Driver) { }
}

export class PersistDriverSuccess implements Action {
  readonly type = PERSIST_DRIVER_SUCCESS;
}

export class PersistDriverFailure implements Action {
  readonly type = PERSIST_DRIVER_FAILURE;
}

export class DeleteDriver implements Action {
  readonly type = DELETE_DRIVER;
  constructor(public driverId: string) { }
}

export class DeleteDriverSuccess implements Action {
  readonly type = DELETE_DRIVER_SUCCESS;
}

export class DeleteDriverFailure implements Action {
  readonly type = DELETE_DRIVER_FAILURE;
}

export class DeactivateDriver implements Action {
  readonly type = DEACTIVATE_DRIVER;
  constructor(public driver: Driver) { }
}

export class DeactivateDriverSuccess implements Action {
  readonly type = DEACTIVATE_DRIVER_SUCCESS;
}

export class DeactivateDriverFailure implements Action {
  readonly type = DEACTIVATE_DRIVER_FAILURE;
}

export type DriversActions = LoadDrivers | LoadDriversSuccess | LoadDriversFailure | LoadDriver | LoadDriverSuccess | LoadDriverFailure |
  PersistDriver | PersistDriverSuccess | PersistDriverFailure | EditDriver | DeleteDriver | DeleteDriverSuccess | DeleteDriverFailure |
  DeactivateDriver | DeactivateDriverSuccess | DeactivateDriverFailure;
